/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ContextSubMenu from 'Common/Components/ContextMenu/components/ContextSubMenu';
import MenuItem from 'Common/Components/ContextMenu/components/MenuItem';
import { useIntl } from 'react-intl';
import { WithPermission } from 'Common/Components/WithPermission';
import {
  FEATURE_CREDENTIALS,
  PERMISSION_TYPES
} from 'Hooks/usePermission/permissions';
import get from 'lodash/get';
import head from 'lodash/head';
import { selectCredentialsSelected } from 'store/Credentials/selectors';
import { EditIcon } from 'Screens/Contextualization/Manage/components/ManageTable/components/ContextMenu/components/styled';
import Owned from './components/Owned';
import { showBulkUpdateModal, showContextMenu, showCredentialDetail } from 'store/Credentials/actions';

export const Edit = () => {
  const dispatch = useDispatch();
  const credentialsSelected = useSelector(selectCredentialsSelected);
  const isBulk = credentialsSelected.length > 1;
  const selectedCredential = head(credentialsSelected);
  const selectedCredentialId = get(selectedCredential, 'id', null);
  const intl = useIntl();
  const id = selectedCredential?.value?.id || selectedCredential?.id;
  const ws = selectedCredential?.value?.workspace_name || selectedCredential?.workspace_name;

  const goToDetail = (inputName) => {
    if (isBulk) dispatch(showBulkUpdateModal(inputName, ''));
    else if (selectedCredentialId) dispatch(showCredentialDetail(true, ws, id));
    dispatch(showContextMenu(false));
  };

  return (
    <WithPermission permission={ FEATURE_CREDENTIALS } type={ PERMISSION_TYPES.UPDATE }>
      <ContextSubMenu
        icon={ <EditIcon /> }
        title={ intl.formatMessage({ id: 'credentials.cm.edit' }) }
      >
        <MenuItem title={ intl.formatMessage({ id: 'credentials.cm.edit.item.clientEndpoint' }) } onClick={ () => goToDetail('endpoint') } />
        <MenuItem title={ intl.formatMessage({ id: 'credentials.cm.edit.item.userName' }) } onClick={ () => goToDetail('username') } />
        <MenuItem title={ intl.formatMessage({ id: 'credentials.cm.edit.item.password' }) } onClick={ () => goToDetail('password') } />
        <MenuItem title={ intl.formatMessage({ id: 'credentials.cm.edit.item.linkedVulnerability' }) } onClick={ () => goToDetail('vulnerabilities') } />
        <Owned />
      </ContextSubMenu>
    </WithPermission>
  );
};
